import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wuliaoxilie",
  "use": "icon-wuliaoxilie-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-wuliaoxilie\"><path d=\"M197.056 478.24H129.568a33.6 33.6 0 0 0 0 67.136h67.488a33.536 33.536 0 1 0 0-67.136z m697.376 0H364.672a33.6 33.6 0 0 0 0 67.136h529.76a33.536 33.536 0 1 0 0-67.136zM197.056 747.136H129.568a33.568 33.568 0 1 0 0 67.104h67.488a33.536 33.536 0 1 0 0-67.104z m697.376 0H364.672a33.6 33.6 0 0 0 0 67.136h529.76a33.536 33.536 0 1 0 0-67.136zM197.056 209.728H129.568a33.6 33.6 0 0 0 0 67.168h67.488a33.6 33.6 0 0 0 0-67.168z m167.616 67.168h529.76a33.6 33.6 0 0 0 0-67.168H364.672a33.6 33.6 0 0 0 0 67.168z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/wuliaoxilie.svg
// module id = VtPZ
// module chunks = 30